import { API_BASE, buildQuery, request } from './api-client';
import type {
  AdminUserDetail,
  AdminUserRow,
  Paginated,
  UserListQuery,
} from '../types';

const BASE = `${API_BASE}/admin/users-mgmt`;

export function listUsers(query: UserListQuery) {
  return request<Paginated<AdminUserRow>>(`${BASE}${buildQuery(query as Record<string, unknown>)}`);
}

export function getUser(id: string) {
  return request<AdminUserDetail>(`${BASE}/${id}`);
}

export function suspendUser(id: string, reason: string) {
  return request<AdminUserRow>(`${BASE}/${id}/suspend`, {
    method: 'PATCH',
    body: JSON.stringify({ reason }),
  });
}

export function restoreUser(id: string) {
  return request<AdminUserRow>(`${BASE}/${id}/restore`, { method: 'POST' });
}

export function deleteUser(id: string) {
  return request<AdminUserRow>(`${BASE}/${id}`, { method: 'DELETE' });
}

export function changeUserRole(id: string, role: string) {
  return request<AdminUserRow>(`${BASE}/${id}/role`, {
    method: 'PATCH',
    body: JSON.stringify({ role }),
  });
}

export function bulkSuspend(userIds: string[], reason: string) {
  return request<{ affected: number }>(`${BASE}/bulk/suspend`, {
    method: 'POST',
    body: JSON.stringify({ userIds, reason }),
  });
}

export function bulkRestore(userIds: string[]) {
  return request<{ affected: number }>(`${BASE}/bulk/restore`, {
    method: 'POST',
    body: JSON.stringify({ userIds }),
  });
}

export function exportUsersCsvUrl(query: UserListQuery) {
  return `${BASE}/export${buildQuery(query as Record<string, unknown>)}`;
}
